var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { version } from './version';
let sentryLoaded = false;
export const initSentry = (enabled) => __awaiter(void 0, void 0, void 0, function* () {
    if (process.env.NODE_ENV === 'development') {
        return;
    }
    if (enabled || sentryLoaded) {
        const [Sentry, { CaptureConsole }, { BrowserTracing }] = yield Promise.all([
            import('@sentry/react'),
            import('@sentry/integrations'),
            import('@sentry/tracing'),
        ]);
        Sentry.init({
            dsn: 'https://bc1312161bf948db9b9c82618035ec22@o1302189.ingest.sentry.io/6539228',
            integrations: [
                new BrowserTracing(),
                new CaptureConsole({
                    levels: ['error'],
                }),
            ],
            sampleRate: 0.25,
            tracesSampleRate: 0.2,
            enabled,
            environment: process.env.NODE_ENV,
            release: version,
        });
        sentryLoaded = true;
    }
});
